export default __webpack_public_path__ + "static/steel-ce28e892e7135bf52f4bc77d489e3ef0.mp4";